<script setup lang="ts">
import type { QuoteData } from '~/utils/crystallize/pieces'

defineProps<{ data: QuoteData }>()
</script>

<template>
  <div v-if="blocksHaveContent(data.text)" class="flex gap-xl col-span-full">
    <div class="aspect-square size-fit hidden sm:block">
      <IconsQuotesAngles class="fill-blurple-200" />
    </div>

    <div class="flex flex-col gap-xl">
      <blockquote>
        <CrystallizeRichText v-for="(block, i) in data.text" :key="i" class="title-m" :block="block" />
      </blockquote>

      <div v-if="data.author?.name">
        <span>–&nbsp;{{ data.author.name }}</span>
        <span v-if="data.author.title">,&nbsp;{{ data.author.title }}</span>
      </div>
    </div>
  </div>
</template>
